import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a virtual_page_view into window.dataLayer on every SPA route change.
 * The path is included but query strings that contain private / random data
 * (?token=, ?seed=, etc.) are stripped before sending.
 */
export default function AnalyticsRouteTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      // Strip volatile / private params
      const strip = ["token", "seed", "state", "code", "external_reference"];
      strip.forEach((k) => url.searchParams.delete(k));
      const cleanSearch = url.searchParams.toString();
      const page_path = pathname + (cleanSearch ? `?${cleanSearch}` : "");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "virtual_page_view",
        page_path,
        page_title: document.title,
        page_location: `${window.location.origin}${page_path}`,
      });
    } catch { /* ignore analytics failures */ }
  }, [pathname, search]);

  return null;
}
